module.exports = __webpack_public_path__ + "img/settings-background.b8492e2f.svg";